import React, { useRef, useState } from 'react';
import { useVisibility } from '@wearejh/react-hooks/lib/useVisibility';

import { Product } from 'src/components/ProductDetail/utils/product-detail.types';
import { ProductPrice } from 'src/types/global-types';

import { Wrapper } from '../Layout';
import { Reviews } from '../Reviews/Reviews';

import classes from './ProductDetail.scss';

type Props = {
    product: Product;
    price: ProductPrice;
    isSignedIn?: boolean;
};

export const ProductReviews = React.memo(function ProductReviews(props: Props) {
    const ref = useRef<HTMLElement>(null);
    const [isReady, setReady] = useState(false);
    useVisibility(ref, setReady, options);
    return (
        <div ref={ref as any}>
            <Wrapper variant="page-inner" id="ProductReviews" className={classes.reviewsLoader}>
                {isReady && <ReviewsInner {...props} />}
            </Wrapper>
        </div>
    );
});

const options: IntersectionObserverInit = {
    rootMargin: '75px',
};

function ReviewsInner(props) {
    const { id, name, url, media_entries } = props.product;
    return (
        <Reviews
            id={id}
            price={props.price.price}
            currency="GBP"
            name={name}
            url={url}
            imageUrl={media_entries[0]?.large_url}
        />
    );
}
